import { Toast } from "../components/ToastComponent";
import { useAuth } from "../routers/AuthProvider";
const DeleteConfirmPopup = ({ onConfirmClick, onCloseClick, id, path }) => {
    const { loading, setLoading } = useAuth();
    return (
        <div className='popup'>
            <p>Are you sure to delete?</p>
            <div className='flex justify-between'>
                <button
                onClick={onCloseClick}
                className='white-btn'
                disabled={loading}
                style={loading ? { opacity: 0.6, cursor: "not-allowed" } : undefined}
                >
                Cancel
                </button>
 
                <button
                onClick={async (e) => {
                    if (loading) return;
                    setLoading(true);
                    try {
                        await onConfirmClick(e, id, path, onCloseClick);
                        await Toast.fire({
                        title: "Successfully Deleted",
                        icon: "success",
                        });
                    } catch (error) {
                        await Toast.fire({
                        title:
                            error?.response?.data?.message ||
                            error?.message ||
                            "Delete failed",
                        icon: "error",
                        });
                    } finally {
                        setLoading(false);
                    }
                }}
                className='red-btn'
                disabled={loading}
                >
                {loading ? "Deleting..." : "Delete"}
                </button>

            </div>
        </div>
    )
}
export default DeleteConfirmPopup;
